// A service's unit, typed (5 November 2026, Cate's levelling at 30 bags × $120: "the quantity unit doesnt give me custom
// option, that line is per bag"). Suggests the six known units; anything else is kept as typed. The value is held here
// while the person types and committed on leaving the box, so a half-typed or empty unit never reaches a save.
import {useEffect,useId,useState} from 'react';
import {SERVICE_UNITS,normaliseServiceUnit} from '@artemis-group/aiw-contracts';
import {useT} from '../lib/i18n';

export function ServiceUnitInput({value,onChange,className}:{value:string;onChange:(unit:string)=>void;className?:string}){
 const {t}=useT(),list=useId(),[draft,setDraft]=useState(value);
 useEffect(()=>setDraft(value),[value]);
 const commit=()=>{const unit=normaliseServiceUnit(draft).slice(0,20);if(!unit){setDraft(value);return;}setDraft(unit);if(unit!==value)onChange(unit);};
 return <><input className={className} list={list} value={draft} maxLength={20} placeholder={t('work.unitHint')} title={t('work.unitHint')}
  onChange={e=>setDraft(e.target.value)} onBlur={commit} onKeyDown={e=>{if(e.key==='Enter'){e.preventDefault();commit();}}}/>
  <datalist id={list}>{SERVICE_UNITS.map(u=><option key={u} value={u}/>)}</datalist></>;
}
